import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import Vue from 'vue';
import Toast from './Toast';
import { mergeDefault } from '../_util';
var globalConfig = {};
var instance;

var createInstance = function createInstance() {
  var root = document.createElement('div');
  var instance = new (Vue.extend(Toast))();
  document.body.appendChild(root);
  instance.$mount(root);
  return instance;
};

var getInstance = function getInstance() {
  if (!instance) {
    instance = createInstance();
  }

  return instance;
};

var toastMethods = {
  config: function config(options) {
    globalConfig = options;
  },
  loading: function loading(duration, onClose) {
    var instance = getInstance();
    instance.open(mergeDefault(globalConfig, {
      duration: duration,
      onClose: onClose,
      type: 'loading'
    }));
    return instance;
  },
  tips: function tips(msg, duration, onClose, type, captureEvt, clickHide) {
    var instance = getInstance();

    if (msg && typeof msg === 'object') {
      // 取 msg.callback 为兼容旧写法
      instance.open(mergeDefault(globalConfig, _extends({}, msg, {
        onClose: msg.onClose || msg.callback
      })));
    } else {
      instance.open(mergeDefault(globalConfig, {
        msg: msg,
        duration: duration,
        onClose: onClose,
        type: type,
        captureEvt: captureEvt,
        clickHide: clickHide
      }));
    }

    return instance;
  },
  success: function success(msg, duration, onClose) {
    var instance = getInstance();
    instance.open(mergeDefault(globalConfig, {
      msg: msg,
      duration: duration,
      onClose: onClose,
      type: 'success'
    }));
    return instance;
  },
  fail: function fail(msg, duration, onClose) {
    var instance = getInstance();
    instance.open(mergeDefault(globalConfig, {
      msg: msg,
      duration: duration,
      onClose: onClose,
      type: 'fail'
    }));
    return instance;
  },
  hide: function hide() {
    var instance = getInstance();
    instance.hide();
    return instance;
  }
};

var UiToast = _extends({
  install: function install(Vue, pname) {
    if (pname === void 0) {
      pname = '$toast';
    }

    Vue.prototype[pname] = _extends({}, toastMethods);
  }
}, toastMethods);

export default UiToast;